import { render, staticRenderFns } from "./CandidateReportsPage.vue?vue&type=template&id=1ca033f6&scoped=true"
import script from "./CandidateReportsPage.vue?vue&type=script&lang=js"
export * from "./CandidateReportsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca033f6",
  null
  
)

export default component.exports